export default `
  metadata(url: $url, locale: $locale) {
    basic {
      title
      description
      indexable
    }
    twitter {
      card
      title
      description
      url
      imageUrl
    }
    og {
      type
      title
      description
      url
      imageUrl
      siteName
      locale
    }
    content {
      title
      subtitle
      body
    }
  }
`;
